import * as React from 'react'

import { useQuery } from '@apollo/client'
import { Grid } from '@factorialco/deprecated-design-system'
import { EmployeePoliciesDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useLegalEntityContractData } from 'modules/contracts/lib/legalEntityContractDataContext'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type Employee from 'modules/employees/store/models/Employee'

import ActivityType from './ActivityType'
import EmploymentType from './EmploymentType'
import FlatRateTax from './FlatRateTax'
import PersonalKeyGroup from './PersonalKeyGroup'

interface Props {
  contractVersion: ContractVersion
  employee: Employee
}

const Germany = ({ contractVersion, employee: _employee }: Props) => {
  const { germanContractData } = useLegalEntityContractData()
  const { data } = useQuery(EmployeePoliciesDocument, {
    variables: { id: _employee.id },
  })
  const canEdit = data?.employees?.employee?._policies?.editContract?.can || false
  const activityTypeId = contractVersion.attributes.de_activity_type
  const employmentTypeId = contractVersion.attributes.de_employment_type
  const flatRateTaxId = contractVersion.attributes.de_flat_rate_tax
  const personalKeyGroupId = contractVersion.attributes.de_personal_key_group_id
  const showActivityType = !!activityTypeId || canEdit
  const showEmploymentType = !!employmentTypeId || canEdit
  const showFlatRateTax = !!flatRateTaxId || canEdit
  const showPersonalKeyGroup = !!personalKeyGroupId || canEdit

  return (
    <Grid variant="fixed">
      {showActivityType && (
        <ActivityType
          activityTypes={germanContractData.activityTypes}
          activityTypeId={activityTypeId || 0}
        />
      )}
      {showEmploymentType && (
        <EmploymentType
          employmentTypes={germanContractData.employmentTypes}
          employmentTypeId={employmentTypeId || 0}
        />
      )}
      {showFlatRateTax && (
        <FlatRateTax
          flatRateTaxes={germanContractData.flatRateTaxes}
          flatRateTaxId={flatRateTaxId || 0}
        />
      )}
      {showPersonalKeyGroup && (
        <PersonalKeyGroup
          personalKeyGroups={germanContractData.personalKeyGroups}
          personalKeyGroupId={personalKeyGroupId || 0}
        />
      )}
    </Grid>
  )
}

export default observer(Germany)
